// mapping between the game mode codes and their readable names

const gamemodeMap = {
  Hue: 'Memory - Hue',
  SatLum: 'Memory - Saturation/Luminosity',
  HSL: 'Memory - Hue/Saturation/Luminosity',

  CompHue: 'Harmony - Complement - Hue',
  CompSL: 'Harmony - Complement - Saturation/Luminosity',
  CompHSL: 'Harmony - Complement - Hue/Saturation/Luminosity',

  SCompHue: 'Harmony - Split-Complement - Hue',
  SCompSL: 'Harmony - Split-Complement - Saturation/Luminosity',
  SCompHSL: 'Harmony - Split-Complement - Hue/Saturation/Luminosity',

  TriadHue: 'Harmony - Triad - Hue',
  TriadSL: 'Harmony - Triad - Saturation/Luminosity',
  TriadHSL: 'Harmony - Triad - Hue/Saturation/Luminosity',

  TetradHue: 'Harmony - Tetrad - Hue',
  TetradSL: 'Harmony - Tetrad - Saturation/Luminosity',
  TetradHSL: 'Harmony - Tetrad - Hue/Saturation/Luminosity',

  GSLum: 'Shade - Colour - Grey',
  GSLumReverse: 'Shade - Grey - Colour',
};

export { gamemodeMap };
